// src/components/countries/Table/CountriesTableRow.jsx
import React from "react";
import { TableRow, TableCell, IconButton, Checkbox } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";

const CountriesTableRow = ({
    country,
    index,
    isDark,
    page,
    perPage,
    sortBy,
    sortDir,
    totalItems,
    selectedIds,
    onRowCheckboxClick,
    onMenuOpen,
    isArchive = false,
    menuDisabled = false
}) => {
    const serial =
        sortDir === "asc"
            ? (page - 1) * perPage + index + 1
            : (page - 1) * perPage + (totalItems - index);

    const isOdd = index % 2 === 0;
    const isSelected = selectedIds.includes(country?.id);

    return (
        <TableRow
            hover
            sx={{
                backgroundColor: isOdd
                    ? isDark
                        ? "rgba(55,65,81,0.45)"
                        : "rgba(249,250,251,0.9)"
                    : "transparent",
            }}
        >
            <TableCell padding="checkbox">
                <Checkbox
                    color="primary"
                    checked={isSelected}
                    onClick={(e) => onRowCheckboxClick(e, country?.id)}
                    inputProps={{ "aria-labelledby": `country-${country?.id}` }}
                />
            </TableCell>

            <TableCell>{serial}</TableCell>

            <TableCell sx={{ color: isDark ? "#E5E7EB" : "#1F2937" }}>
                {country?.name?.ar}
            </TableCell>

            <TableCell sx={{ color: isDark ? "#E5E7EB" : "#1F2937" }}>
                {country?.name?.en}
            </TableCell>

            <TableCell sx={{ color: isDark ? "#E5E7EB" : "#1F2937" }}>
                {country?.code}
            </TableCell>

            <TableCell align="right">
                <IconButton
                    size="small"
                    disabled={menuDisabled}
                    onClick={(e) => {
                        e.stopPropagation();
                        onMenuOpen(e, country);
                    }}
                    sx={{ color: isDark ? "#E5E7EB" : "#1F2937" }}
                >
                    <MoreVertIcon fontSize="small" />
                </IconButton>
            </TableCell>
        </TableRow>
    );
};

export default CountriesTableRow;
